
// export default EditEmployeeModal;
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateParkUser } from "../../redux/actions/parkEmployeeActions";
import { fetchDistricts, fetchMunicipalities } from "../../redux/actions/locationActions";
import theme from "../../components/shared/theme";
import { inputStyle, modalContentStyle, modalOverlayStyle, closeButtonStyle } from "../../components/shared/themeStyles";
import toast from "react-hot-toast";

const EditEmployeeModal = ({ employee, onChange, onCancel }) => {
  const dispatch = useDispatch();
  const { districts, municipalities } = useSelector((state) => state.location);

  useEffect(() => {
    dispatch(fetchDistricts());
    dispatch(fetchMunicipalities());
  }, [dispatch]);

  if (!employee) return null;

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();

    const formatDate = (dateString) => {
      if (!dateString) return null;
      return dateString.includes("T") ? dateString.split("T")[0] : dateString;
    };

    const payload = {
      name: employee.name,
      email: employee.email,
      phone: employee.phone,
      dob: formatDate(employee.dob),
      doj: formatDate(employee.doj),
      district_id: employee.district_id,
      municipality_id: employee.municipality_id,
      status: employee.status || "active",
    };

    try {
      await dispatch(updateParkUser(employee.id, payload));
      toast.success("Employee updated successfully");

      // ✅ Update parent table and close modal
      onChange("updateTable", payload);
      onCancel();
    } catch (err) {
      console.error(err);
      toast.error("Failed to update employee");
    }
  };

  return (
    <div style={{ ...modalOverlayStyle, display: "flex", justifyContent: "center", alignItems: "center", padding: "1rem" }}>
      <div style={{ ...modalContentStyle, maxWidth: "600px", width: "100%" }}>
        <button onClick={onCancel} style={closeButtonStyle}>&times;</button>
        <h2 style={{ marginBottom: theme.spacing.md, fontSize: theme.font.size.xl, fontWeight: theme.font.weight.bold }}>
          Update Employee
        </h2>

        <form onSubmit={handleUpdateSubmit}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
            <input
              style={inputStyle}
              type="text"
              value={employee.name}
              onChange={(e) => onChange("name", e.target.value)}
              placeholder="Name"
            />
            <input
              style={inputStyle}
              type="text"
              value={employee.email}
              onChange={(e) => onChange("email", e.target.value)}
              placeholder="Email"
            />
            <input
              style={inputStyle}
              type="text"
              value={employee.phone}
              onChange={(e) => onChange("phone", e.target.value)}
              placeholder="Phone"
            />

            {/* DOB Editable */}
            <input
              style={inputStyle}
              type="date"
              value={employee.dob ? employee.dob.split("T")[0] : ""}
              onChange={(e) => onChange("dob", e.target.value)}
            />

            {/* DOJ Editable */}
            <input
              style={inputStyle}
              type="date"
              value={employee.doj ? employee.doj.split("T")[0] : ""}
              onChange={(e) => onChange("doj", e.target.value)}
            />

            <select
              style={inputStyle}
              value={employee.district_id || ""}
              onChange={(e) => {
                const selectedId = parseInt(e.target.value);
                const selected = districts.find((d) => d.id === selectedId);
                onChange("district_id", selectedId);
                onChange("district", selected?.name || "");
              }}
            >
              <option value="">Select District</option>
              {districts?.map((dist) => (
                <option key={dist.id} value={dist.id}>{dist.name}</option>
              ))}
            </select>

            <select
              style={inputStyle}
              value={employee.municipality_id || ""}
              onChange={(e) => {
                const selectedId = parseInt(e.target.value);
                const selected = municipalities.find((m) => m.id === selectedId);
                onChange("municipality_id", selectedId);
                onChange("municipality", selected?.name || "");
              }}
            >
              <option value="">Select Municipality</option>
              {municipalities?.map((muni) => (
                <option key={muni.id} value={muni.id}>{muni.name}</option>
              ))}
            </select>
          </div>

          <div style={{ marginTop: theme.spacing.lg, textAlign: "right" }}>
            <button type="submit" style={{ backgroundColor: theme.colors.primary, color: "#fff", padding: theme.spacing.sm, borderRadius: theme.radius.md }}>
              Update
            </button>
            <button
              type="button"
              onClick={onCancel}
              style={{
                backgroundColor: "#eee",
                color: "#000",
                padding: theme.spacing.sm,
                borderRadius: theme.radius.md,
                marginLeft: theme.spacing.sm,
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEmployeeModal;
